import React, { useEffect, useState } from "react";
import "@/index.scss";
import Header from "@/components/Layouts/Header/Header";
import NavBar from "@/components/Layouts/NavBar/NavBar";
import Main from "@/components/Layouts/Main/Main";
import AppMsalProvider from "@/features/auth/msal-provider";
import config from "@/config";
import AuthRouter from "@/features/auth/auth-router";
import ErrorBoundary from "@/pages/ErrorBoundary/ErrorBoundary";
import GlobalErrorPopup from "@/features/errors/GlobalErrorPopup";
import { useTranslation } from "react-i18next";
import { MOBILE_BREAKPOINT } from "@/Constant";

const { features } = config;

function App() {
  const [collapse, setCollapse] = useState(false);
  const { t } = useTranslation();

  let screenWidth = window.outerWidth;

  window.addEventListener("resize", () => {
    screenWidth = window.outerWidth;
    if (screenWidth <= MOBILE_BREAKPOINT) {
      setCollapse(true);
    }
  });
  useEffect(() => {
    let screenWidth = window.outerWidth;
    if (screenWidth <= MOBILE_BREAKPOINT) {
      setCollapse(true);
    }
  }, []);

  useEffect(() => {
    document.body.classList.toggle("sidebar-collapsed", collapse);
    return () => {
      document.body.classList.remove("sidebar-collapsed");
    };
  }, [collapse]);

  useEffect(() => {
    const originalConsoleError = console.error;

    console.error = (...args: any[]) => {
      if (typeof args[0] === "string" && /defaultProps/.test(args[0])) {
        return;
      }

      if (
        typeof args[0] === "string" &&
        /Did you mean to use React.forwardRef()/.test(args[0])
      ) {
        return;
      }
      originalConsoleError(...args);
    };

    return () => {
      console.error = originalConsoleError;
    };
  }, []);
  if (features.sso) {
    return (
      <AppMsalProvider>
        <div className="motif-theme-light">
          <GlobalErrorPopup />
          <Header setCollapse={setCollapse} collapse={collapse} />

          <NavBar setCollapse={setCollapse} collapse={collapse} />

          <ErrorBoundary
            heading={t("global.globalNotifications.wentWrong")}
            description1={t("global.globalNotifications.tryRefershing")}
            buttonName={t("global.globalActions.clickHere")}
            description2={t("global.globalNotifications.goBackHome")}
          >
            <AuthRouter>
              <Main collapse={collapse} />
            </AuthRouter>
          </ErrorBoundary>
        </div>
      </AppMsalProvider>
    );
  }
  return (
    <div className="motif-theme-light">
      <Header setCollapse={setCollapse} collapse={collapse} hideAvatar={true} />
      <NavBar setCollapse={setCollapse} collapse={collapse} />
      <Main collapse={collapse} />
    </div>
  );
}

export default App;
